import { AppointmentBooking } from "@/components/appointment-booking";
import { NavigationHeader } from "@/components/navigation-header";
import { SEOHead } from "@/components/seo-head";

const Booking = () => {
  return (
    <div className="min-h-screen bg-background relative">{/* Added relative for navigation positioning */}
      <SEOHead 
        title="Reservar Cita - MKTN GUARDIANS"
        description="Agenda una consultoría gratuita personalizada para tu estrategia de marketing digital. Especialistas en placas solares y reformas."
      />
      
      {/* Navigation Header */}
      <NavigationHeader />
      
      <div className="py-12 sm:py-20 pt-20 sm:pt-24">{/* Added top padding for navigation */}
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4">
              Reserva tu <span className="text-primary">Consultoría Gratuita</span>
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto">
              Agenda una reunión personalizada para analizar cómo podemos ayudarte a conseguir más clientes
            </p>
          </div>
          
          <AppointmentBooking />
        </div>
      </div>
    </div>
  );
};

export default Booking;